export default "/images/icons8-usa.png?6d753cbc54991b8d58f4a74aec64a5e9";